import axios from 'axios'

const URL_API = 'https://potenciasperifericas.org.br/api/v1'

export default class CepLocationApi {
    getConfig() {
        const localStorageKeys = Object.keys(localStorage)
        let token = ''

        if (localStorageKeys.includes('usuario')) {
            token = localStorage.getItem('usuario') ? JSON.parse(localStorage.getItem('usuario')).token : ''
        } else if (localStorageKeys.includes('authentication-admin')) {
            token = localStorage.getItem('authentication-admin') ? JSON.parse(localStorage.getItem('authentication-admin')).token : ''
        }

        return {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }
    }

    getCep(cep) {
        return axios.get(`${URL_API}/get-address/${cep}`, this.getConfig())
    }
}



// WEBPACK FOOTER //
// ./src/api/cep-location/CepLocationApi.js